import { Card, Col, Form, Input, Row, Select, TreeSelect } from "antd";
import { get, includes, join, map, size, toLower } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeVietnameseTones } from "../../../../../lib/admin";
import { convertStationGate } from "../../../../../lib/util";
import { PAGINATION } from "../../_redux/constant";
import { barrierThunks } from "../../_redux/thunk";
import Camera from "../../components/view-camera/cameraList";

let timer = null;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;
function BarrierCameraViewPage() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { direction, stations, station_gates } = useSelector(
    state => state.barrier.barrierLog.filterData
  );

  const { data, total_elements } = useSelector(
    state => state.barrier.barrierCamera.camera
  );

  const [params, setParams] = useState({
    size: PAGINATION.camera.size,
    page: PAGINATION.camera.page
  });

  const [loading, setLoading] = useState(false);

  const dataSource = map(data, (item, index) => ({
    ...item,
    stt:
      params.page === 0
        ? index + 1
        : (params.page - 1) * params.size + index + 1
  }));

  const _handleGetFilterData = useCallback(async () => {
    await dispatch(barrierThunks.getLogFilterDataThunk());
  }, [dispatch]);

  const _handleGetCameras = useCallback(async () => {
    setLoading(true);
    await dispatch(barrierThunks.getCameraThunk(params));
    setLoading(false);
  }, [params, dispatch]);

  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 500);
  };

  const _handleChangeFilter = () => {
    const { direction, station_id, ip, camera_status, pc_status } =
      form.getFieldsValue();

    setParams(prev => ({
      ...prev,
      direction,
      station_id,
      ip,
      page: PAGINATION.camera.page,
      size: PAGINATION.camera.size,
      camera_status,
      pc_status
    }));
  };

  const onChangeParam = param => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.camera.page;
      param.size = PAGINATION.camera.size;
    }
    setParams(prev => ({ ...prev, ...param }));
  };

  const _handleChangeParam = useCallback(
    async ({ gateIds, stationIds }) => {
      const { direction, ip, camera_status, pc_status } = form.getFieldsValue();

      setParams(prev => ({
        ...prev,
        direction,
        ip,
        gate_ids:
          gateIds && size(gateIds) && size(join(gateIds, ","))
            ? join(gateIds, ",")
            : "",
        station_ids:
          stationIds && size(stationIds) && size(join(stationIds, ","))
            ? join(stationIds, ",")
            : "",
        page: PAGINATION.camera.page,
        size: PAGINATION.camera.size,
        camera_status,
        pc_status
      }));
    },
    [form]
  );

  useEffect(() => {
    _handleGetFilterData();
    _handleGetCameras();
  }, [_handleGetFilterData, _handleGetCameras]);

  return (
    <Row className="barrier-log__page" gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form form={form} layout={"vertical"} style={{ width: "100%" }}>
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item
                    colon={false}
                    label="Kho"
                    labelAlign="left"
                    labelCol={{ span: 3 }}
                  >
                    <TreeSelect
                      multiple
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: "auto",
                        overflowX: "hidden"
                      }}
                      filterTreeNode={(input, treeNode) => {
                        return includes(
                          toLower(
                            removeVietnameseTones(get(treeNode, "title"))
                          ),
                          toLower(removeVietnameseTones(input))
                        );
                      }}
                      placeholder="Chọn kho"
                      showCheckedStrategy={SHOW_PARENT}
                      style={{ width: "100%" }}
                      treeCheckable={true}
                      onChange={data => {
                        _handleChangeParam(convertStationGate(data, stations));
                      }}
                    >
                      {map(station_gates, station => {
                        return (
                          <TreeNode
                            key={station.station_name}
                            selectable={false}
                            title={station.station_name}
                            value={station.station_name}
                          >
                            {map(station.gates, gate => {
                              return (
                                <TreeNode
                                  key={gate.gate_id}
                                  selectable={false}
                                  title={gate.gate_name}
                                  value={gate.gate_id}
                                />
                              );
                            })}
                          </TreeNode>
                        );
                      })}
                    </TreeSelect>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item label="IP camera" name="ip">
                    <Input
                      placeholder={"IP camera"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item label="Trạng thái camera" name="camera_status">
                    <Select
                      allowClear
                      placeholder={"Trạng thái camera"}
                      onChange={_handleChangeInput}
                      options={[
                        {
                          value: 1,
                          label: "ONLINE"
                        },
                        {
                          value: 0,
                          label: "OFFLINE"
                        }
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item label="Trạng thái pc" name="pc_status">
                    <Select
                      allowClear
                      placeholder={"Trạng thái pc"}
                      onChange={_handleChangeInput}
                      options={[
                        {
                          value: 1,
                          label: "ONLINE"
                        },
                        {
                          value: 0,
                          label: "OFFLINE"
                        }
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <Camera
          loading={loading}
          dataSource={dataSource}
          total_elements={total_elements}
          params={params}
          onChangeParam={onChangeParam}
          directions={direction}
        />
      </Col>
    </Row>
  );
}

export default React.memo(BarrierCameraViewPage);
